module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114124_89_157.66dbd14.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114124_89_157.jpg
// module id = 30ZH
// module chunks = 0